import {
  ACESFilmicToneMapping,
  Clock,
  //  ColorManagement,
  PerspectiveCamera,
  Scene,
  sRGBEncoding,
  Vector2,
  WebGLRenderer,
} from 'three'
const CAMERA_DISTANCE = 60

export default class Common {
  sizes: Vector2 = new Vector2()
  pixelRatio: number = 1.5
  aspect: number = 0
  scene: Scene = new Scene()
  camera: PerspectiveCamera = new PerspectiveCamera(10, 1, 0.1, 200)
  wrapperOffset: Vector2 = new Vector2()
  delta: number = 0
  time: number = 0
  declare clock: Clock
  canvasWrapper: HTMLElement
  declare renderer: WebGLRenderer
  cameraDistance: number = 60
  copilotArea: HTMLElement
  canvas: HTMLCanvasElement
  copilotAreaOffset: Vector2 = new Vector2()
  wrapperDimentions: Vector2 = new Vector2()
  isMobile: boolean = false
  constructor(canvasWrapper: HTMLElement, copilotArea: HTMLElement, canvas: HTMLCanvasElement, pixelRatio: number) {
    this.aspect = 1

    this.canvasWrapper = canvasWrapper
    this.copilotArea = copilotArea
    this.canvas = canvas

    this.camera.position.set(0, 0, this.cameraDistance)
    this.scene.add(this.camera)
    //ColorManagement.enabled = true
    this.delta = 0
    this.time = 0

    this.init(pixelRatio)
  }

  init(pixelRatio: number) {
    this.clock = new Clock()

    this.pixelRatio = Math.min(window.devicePixelRatio, pixelRatio)

    this.renderer = new WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
    })

    this.renderer.setPixelRatio(this.pixelRatio)
    this.renderer.outputEncoding = sRGBEncoding
    this.renderer.toneMapping = ACESFilmicToneMapping
    this.renderer.toneMappingExposure = 1.5
    this.renderer.setClearColor(0xffffff, 0.0)

    this.resize()
  }

  scroll() {
    const wrapperRect = this.canvasWrapper.getBoundingClientRect()
    const copilotRect = this.copilotArea.getBoundingClientRect()

    this.copilotAreaOffset.set(
      copilotRect.left - wrapperRect.left + copilotRect.width / 2 - wrapperRect.width / 2,
      -(copilotRect.top - wrapperRect.top + copilotRect.height / 2 - wrapperRect.height / 2) -
        (this.sizes.y - wrapperRect.height) * 0.5,
    )

    this.wrapperOffset.set(wrapperRect.left, wrapperRect.top)
  }

  resize() {
    this.isMobile = window.innerWidth < 768
    const wrapperRect = this.canvasWrapper.getBoundingClientRect()
    const width = wrapperRect.width
    let height = wrapperRect.height

    this.wrapperDimentions.set(width, height)

    const copilotRect = this.copilotArea.getBoundingClientRect()

    const top = wrapperRect.top - copilotRect.top
    // let left = wrapperRect.left - copilotRect.left;
    height += top

    this.aspect = width / height
    this.sizes.set(width, height)

    const cameraDistanceScale = height / copilotRect.height

    this.camera.position.z = CAMERA_DISTANCE * cameraDistanceScale
    this.cameraDistance = this.camera.position.z

    this.camera.aspect = this.aspect
    this.camera.updateProjectionMatrix()

    this.renderer.setSize(width, height)

    this.scroll()
  }

  update() {
    const delta = this.clock.getDelta()
    this.delta = delta
    this.time += this.delta
  }
}
